export const TENANTS_PARKING_REQUESTED = 'TENANTS_PARKING_REQUESTED';
export const TENANTS_PARKING_SUCCESS = 'TENANTS_PARKING_SUCCESS';
export const TENANTS_PARKING_FAILED = 'TENANTS_PARKING_FAILED';
